<template>
  <div class="mobiletProduct">
    <div class="header">
      <a href="javascript:;"
         @click="$router.back(-1)">
        <van-icon name="arrow-left"
                  class="header-left" />
      </a>
      <span>{{title}}</span>
    </div>
    <Header :product="product"
            :specs="specs" />
    <Specs :product="product"
           :specs="specs"
           @changeSpecs="changeSpecs"
           @changeNumber="changeNumber"
           @changeShow="changeShow"
           v-if="specs[0]" />
    <div class="descContent">
      <h2>详细说明</h2>
      <div class="tabs-content-table"
           v-html="product.desc"></div>
    </div>
    <Content :account="account"
             @changeContent="changeContent" />
    <div class="productFooter clearfix">
      <div v-if="specs[0]"
           class="left">
        合计:
        <span>
          <em>¥</em>
          {{Math.abs((parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)-product.bonus_price)*number)}}
        </span>
      </div>
      <div class="left"
           v-else>
        合计:
        <span>
          <em>¥</em>
          {{Math.abs((parseInt(product.price))*number)}}
        </span>
      </div>
      <div class="right">
        <van-button type="danger"
                    v-if="!loadding"
                    @click="Next()">提交订单</van-button>
        <van-button loading
                    type="danger"
                    v-else
                    loading-type="spinner"
                    loading-text="提交中..." />
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt, setCookie } from "@/utils";

import Header from "@/components/Mobile/tProduct/Header.vue";
import Specs from "@/components/Mobile/Product/Specs.vue";
import Content from "@/components/Mobile/Product/Content.vue";

export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      specs: [
        // {value:1,price:0},
        // {value:2,price:0},
      ],
      amount: 0,
      form: {
        name: "",
        phone: "",
        city: [],
        address: ""
      },
      number: 1,
      loadding: false,
      title: ""
    };
  },
  components: {
    Header,
    Specs,
    Content
  },
  mounted: function () {
    window.scroll(0, 0);
    window.addEventListener("scroll", () => {
      // console.log(this.$refs.product.scrollTop);
    });
    this.form = this.info;
  },
  computed: {
    product () {
      return this.$store.state.product.product;
    },
    assess () {
      return this.$store.state.assess.assess;
    },
    account () {
      return this.$store.state.account.user;
    },
    info () {
      return this.$store.state.user.info;
    }
  },
  methods: {
    fetchProductData (params) {
      this.$store.dispatch("product/fetchProductData", { params }).then(() => {
        this.title = this.product.title;
        for (let i = 0; i < this.product.attr.length; i++) {
          for (let j = 0; j < this.product.attr[i]["attr_value"].length; j++) {
            if (j == 0) {
              let data = {
                value: this.product.attr[i]["attr_value"][0]["attr_value_id"],
                price: this.product.attr[i]["attr_value"][0]["attr_price"],
                name: this.product.attr[i]["attr_value"][0]["attr_value_name"]
              };
              this.specs.push(data);
            }
          }
        }
        this.amount = this.product.price;
      });
    },
    changeSpecs (data) {
      console.log(data);
      this.specs = data;
    },
    changeNumber (data) {
      this.number = data;
    },
    changeShow (data) {
      this.show = !this.show;
    },
    changeContent (value) {
      this.form = value;
    },
    handleScroll () {
      var sortMenu = this.$refs.product.scrollTop;
    },
    Next () {
      this.$toast("活动已结束.");
      return false;
      if (!this.account.userid) {
        this.$toast("请先获取验证码登录.");
        return false;
      }
      let params = {
        phone: this.account.mobile
      };
      this.$store.dispatch("account/fetchLoginData", { params }).then(() => {
        if (this.$store.state.account.user.orderTotal) {
          this.$toast("您已参与过活动。");
          return false;
        } else {
          this.CreateOrder();
        }
      });
    },
    onLogin () {

    },
    CreateOrder () {
      // this.$toast("活动已结束.");
      // return false;
      let attrids = "";
      let attrs = "";
      let amount =
        parseInt(this.product.price) - parseInt(this.product.bonus_price);
      for (let i = 0; i < this.specs.length; i++) {
        attrids += this.specs[i].value + ",";
        attrs += this.specs[i].name + ",";
        amount += parseInt(this.specs[i].price);
      }
      if (!this.info.name) {
        this.$toast("请输入姓名.");
        return false;
      }

      this.loadding = !this.loadding;
      let params = {
        goodsId: this.product.id,
        name: this.info.name,
        userId: this.account.userid,
        mobile: this.account.mobile,
        bonusId: 0,
        address: this.info.city + this.info.address,
        referer: "以旧换新 新机活动乐享",
        source: 1,
        amount: parseInt(amount * this.number),
        bonus: 0,
        attrvalueId: attrids,
        attribute: attrs,
        parentId: "0"
      };
      this.$store.dispatch("order/fetchCreateData", { params }).then(() => {
        let orderdata = JSON.stringify(this.$store.state.order.orderdata);
        setCookie("orderdata", encrypt(orderdata), true);
        this.$router.push({ path: "/mobile/tcheckout" });
      });
    }
  },
  created () {
    let id = this.$route.params.id;
    let params = {
      id: id
    };
    this.fetchProductData(params);
  },
  watch: {}
};
</script>
<style>
.mobiletProduct {
  background: #f5f5f5;
  padding: 0rem 0 1rem;
}
.mobiletProduct .header {
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: center;
  position: relative;
  background: #fff;
  font-size: 0.17rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.mobiletProduct .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.13rem;
}
.mobiletProduct .header span {
  display: inline-block;
  width: 2rem;
  overflow: hidden;
  height: 0.44rem;
}
.mobiletProduct .productFooter {
  box-shadow: #efefef 0 0 0.1rem;
  height: 0.63rem;
  position: fixed;
  width: 100%;
  background: #fff;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.mobiletProduct .productFooter .left {
  float: left;
  line-height: 0.63rem;
  color: #f9415d;
  padding-left: 0.1rem;
}
.mobiletProduct .productFooter .left span {
  font-size: 0.24rem;
}
.mobiletProduct .productFooter .left em {
  font-style: normal;
  font-size: 0.14rem;
}
.mobiletProduct .productFooter .right {
  float: right;
  display: flex;
  font-size: 0.14rem;
}
.mobiletProduct .productFooter .right .right-text {
  text-align: center;
  margin-right: 0.12rem;
  color: #333;
  padding: 0.13rem 0;
}
.mobiletProduct .productFooter .right .right-text span:nth-child(1) {
  display: block;
  font-size: 0.2rem;
  color: #f9415d;
}
.mobiletProduct .productFooter .right .right-text span em {
  font-style: normal;
  font-size: 0.12rem;
}
.mobiletProduct .productFooter .right button {
  display: inline-block;
  width: 1.4rem;
  height: 0.63rem;
  background: rgba(249, 65, 93, 1);
  font-size: 0.15rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.item-content-img {
  width: 3.48rem;
  height: 1.6rem;
  background: url(../../../assets/image/mobileStepBg.png) no-repeat;
  background-size: 100%;
  margin-top: 0.1rem;
}
.descContent {
  background: #fff;
  padding: 0.1rem;
  margin-top: 0.1rem;
}
.descContent h2 {
  font-size: 0.16rem;
  font-weight: normal;
  margin: 0.1rem;
}
</style>
